import "./App.css";
import Navbars from "./Components/Navbar/Navbars";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { Home } from "./pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./Components/Footer";
import About from "./pages/About";
// import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Service from "./pages/Service";
// import 'reactjs-popup/dist/index.css';

import { AnimatePresence } from "framer-motion";

import MetaTags from "react-meta-tags";
import PageNotFound from "./pages/PageNotFound";
import ComingSoon from "./pages/ComingSoon";
import Disclaimer from "./pages/Disclaimer";

function App() {
  const location = useLocation();

  return (
    <div
      style={{
        backgroundColor: "#011a27",
        height: "100%",
      }}
    >
      <MetaTags>
        <title>Vibgyor Advisors</title>
        <meta httpEquiv="x-ua-compatible" content="IE=edge"></meta>
        <meta name="color-scheme" content="dark light"></meta>
      </MetaTags>

      <Navbars />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.key}>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          {/* <Route path="/contact" exact component={Contact} /> */}
          <Route path="/services" exact component={Service} />
          <Route path="/careers" exact component={Careers} />
          <Route path="/realestate" exact component={ComingSoon} />
          <Route path="/disclaimer" exact component={Disclaimer} />
          <Route path="*" exact component={PageNotFound} />
        </Switch>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
